<template>
  <mdb-container fluid>
    <material-card
      title="Bedarfsmedikation"
      card-icon="file-prescription"
    >
      <template v-slot:actions>
        <mdb-btn
          color="#333"
          class="py-2 px-3 z-depth-0 border border-light rounded"
          @click="modal = !modal"
        >
          <mdb-icon
            color="black"
            icon="plus"
          />
        </mdb-btn>
        <mdb-btn
          v-if="valueSelected"
          color="#333"
          class="py-2 px-3 mr-2 z-depth-0 border border-light rounded"
          @click="modalSetting = !modalSetting"
        >
          <mdb-icon
            color="black"
            icon="cog"
          />
        </mdb-btn>
        <mdb-select
          outline
          class="d-inline-flex w-80"
          wrapperClass="mt-0 mb-0 w-100"
          v-model="selectOption"
          placeholder="Grund auswählen"
          @getValue="selectValue"
        />

        <div class="d-flex justify-content-center">
          <mdb-spinner big v-if="loading"/>
        </div>
      </template>
      <template
        v-if="valueSelected"
        v-slot:content
      >
        <mdb-btn
          color="primary"
          class="mb-3"
          @click="medicineModal = !medicineModal"
        >
          Medikament <mdb-icon icon="plus" class="mr-1"/>
        </mdb-btn>
        <div>
          <mdb-accordion
            table
            v-if="selectedBedarfsmedikation.Medikamente.length > 0"
          >
            <mdb-accordion-pane
              class="d-flex mb-2"
              title=""
              type="table"
              shades="teal"
              v-for="(medicine, index) in selectedBedarfsmedikation.Medikamente"
              :key="index"
              :isOpen="openPaneNum==index"
              @pane-clicked="handlePaneOpened(index)"
            >
              <span
                class="h6 mb-0 float-left"
                text="primary"
                slot="title"
              >
                {{ medicine.Medikament }}
                <mdb-badge
                  pill
                  class="ml-2"
                  color="orange"
                >
                  Prio {{ medicine.Prio }}
                </mdb-badge>
              </span>
              <div class="p-2 mx-3 mb-2">
                <mdb-tbl
                  striped
                  bordered
                  hover
                >
                  <mdb-tbl-body>
                    <tr
                      v-for="(t, i) in titleBedarfsmedikation"
                      :key="i"
                      :class="medicine[t.id] ? 'd-flex-box' : 'd-none'"
                    >
                      <td>
                        <strong>
                          <mdb-icon :icon="t.icon" />  {{ t.title }}
                        </strong>
                      </td>
                      <td v-if="medicine[t.id] && t.type == 'String'">
                        {{ medicine[t.id] }}
                      </td>
                      <td v-else-if="medicine[t.id] && t.type == 'Date'">
                        {{ medicine[t.id] | dateFormat }}
                      </td>
                      <td v-else-if="t.id && t.type == 'Boolean'">
                        <mdb-icon
                          :icon="medicine[t.id] ? 'check-circle' : 'times-circle'"
                          :class="medicine[t.id] ? 'green-text' : 'red-text'" />
                      </td>
                      <td v-else-if="medicine[t.id] && t.type == 'Star'">
                        <mdb-icon icon="star" class="blue-text " /> {{ medicine[t.id] }}
                      </td>
                      <td v-else> - </td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
                <mdb-btn
                  v-show="!isChecked"
                  size="md"
                  color="red darken-2"
                  @click="openDeleteModal(medicine.Id)"
                >
                  <mdb-icon icon="file-excel" class="mr-1"/> Absetzen
                </mdb-btn>
              </div>
            </mdb-accordion-pane>
          </mdb-accordion>
          <list-group-item
            v-else
            :title="'Keine Einträge gefunden'"
          />

          <mdb-btn
            color="primary"
            class="mb-3"
            @click="openCourseModal"
          >
            Verlauf <mdb-icon icon="plus" class="mr-1"/>
          </mdb-btn>
          <mdb-accordion
            table
            v-if="selectedBedarfsmedikation.Verlauf.length > 0"
          >
            <mdb-accordion-pane
              class="d-flex mb-1"
              title=""
              type="table"
              shades="teal"
              v-for="(course, index) in selectedBedarfsmedikation.Verlauf"
              :key="index"
              :isOpen="openPaneNumCourse==index"
              @pane-clicked="courseFandlePaneOpened(index)"
            >
              <mdb-chip
                color="primary lighten-4 float-left mb-0"
                text="primary"
                slot="title"
                class="px-2 mr-1"
              >
                {{ course.Datum | dateFormat }}
              </mdb-chip>
              <span
                slot="title"
                class="float-left px-2 mt-1"
              >
                {{ course.Medikament }}
              </span>
              <mdb-badge
                class="float-right px-2 mx-2 mt-1"
                slot="title"
                color="info"
              >
                {{ course.AenderungVon }}
              </mdb-badge>

              <div class="p-2 mb-3 mx-3 mb-4">
                <mdb-tbl
                  striped
                  hover
                >
                  <mdb-tbl-body>
                    <tr
                      v-for="(t, i) in titleVerlaufBedarfsmedikation"
                      :key="i"
                      class="mdb-color grey lighten-3"
                    >
                      <td>
                        <strong>
                          <mdb-icon :icon="t.icon" />  {{ t.title }}
                        </strong>
                      </td>
                      <td v-if="course[t.id] && t.type == 'String'">
                        {{ course[t.id] }}
                      </td>
                      <td v-else-if="course[t.id] && t.type == 'ID'">
                        {{ t.id == 'Schicht' ? schichtValue(course.Schicht) : ''}}
                      </td>
                      <td v-else-if="course[t.id] && t.type == 'Date'">
                        {{ course[t.id] | dateFormat }}
                      </td>
                      <td v-else-if="t.id && t.type == 'Boolean'">
                        <mdb-icon
                          :icon="course[t.id] ? 'check-circle' : 'times-circle'"
                          :class="course[t.id] ? 'green-text' : 'red-text'" />
                      </td>
                      <td v-else-if="course[t.id] && t.type == 'Star'">
                        <mdb-icon icon="star" class="blue-text " /> {{ course[t.id] }}
                      </td>
                      <td v-else> - </td>
                    </tr>
                  </mdb-tbl-body>
                </mdb-tbl>
              </div>
            </mdb-accordion-pane>
          </mdb-accordion>
          <list-group-item
            v-else
            :title="'Keine Einträge gefunden'"
          />
        </div>
      </template>
    </material-card>
    <add-medicine-report-modal
      :modal-state="modal"
      @close="modal = false"
      @save="loadBedarfsmedikation"
    />
    <add-medicine-modal
      :modal-state="medicineModal"
      :medication="medication"
      @close="medicineModal = false"
      @save="loadBedarfsmedikation"
    />
    <add-course-modal
      :modal-state="courseModal"
      :medication="medication"
      :medicine="medicine"
      @close="closeCourseModal"
      @save="loadBedarfsmedikation"
    />
    <setting-modal
      :modal-state="modalSetting"
      @close="closeSettings"
      @filter="loadBedarfsmedikation"
    >
     <template v-slot:content>
        <mdb-input
          class="my-2"
          type="checkbox"
          id="cancelled"
          v-model="isChecked"
          name="abgesetzte_medikamente_anzeigen"
          label="abgesetzte Medikamente anzeigen"
        />
     </template>
    </setting-modal>
    <delete-modal
      :modal-state="modalDelete"
      title="Medikament absetzen?"
      description="Wollen Sie das Medikament Bromazepam wirklich absetzen?"
      @close="close"
      @save="deleteMedicine"
    />
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbBtn,
  mdbSelect,
  mdbIcon,
  mdbAccordion,
  mdbAccordionPane,
  mdbTbl,
  mdbTblBody,
  mdbInput,
  mdbBadge,
  mdbChip,
  mdbSpinner
} from 'mdbvue';
const MaterialCard = () => import('@/components/card/MaterialCard')
const AddMedicineReportModal = () => import('@/components/modals/AddMedicineReportModal')
const AddMedicineModal = () => import('@/components/modals/AddMedicineModal')
const AddCourseModal = () => import('@/components/modals/AddCourseModal')
const SettingModal = () => import('@/components/modals/SettingModal')
const DeleteModal = () => import('@/components/modals/DeleteModal')
const ListGroupItem = () => import('@/components/accordion/ListGroupItem')
import utils from '@/mixins/Utils'

export default {
  name: 'Bedarfsmedikation',
  mixins: [utils()],
  components: {
    mdbContainer,
    mdbBtn,
    mdbSelect,
    mdbIcon,
    AddMedicineReportModal,
    AddMedicineModal,
    AddCourseModal,
    SettingModal,
    DeleteModal,
    ListGroupItem,
    mdbAccordion,
    mdbAccordionPane,
    MaterialCard,
    mdbTbl,
    mdbTblBody,
    mdbInput,
    mdbBadge,
    mdbChip,
    mdbSpinner
  },

  data () {
    return {
      modal: false,
      isChecked: false,
      modalSetting: false,
      medicineModal: false,
      modalDelete: false,
      courseModal: false,
      openPaneNum: null,
      openPaneNumCourse: null,
      valueSelected: false,
      selectedItem: null,
      loading: false,
      medication: {
        id: null,
        grund: ''
      },
      bedarfsmedikation: [],
      medicine: [],
      selectOption: [],
      selectedBedarfsmedikation: [],
      url: '',
      deleteMedicineID: null,
      titleBedarfsmedikation: [
        {
          title: 'Dosierung',
          id: 'Dosierung',
          icon: 'pills',
          type: 'String'
        },
        {
          title: 'Max. Dosierung',
          id: 'MaxDosierung',
          icon: 'exclamation-triangle',
          type: 'String'
        },
        {
          title: 'Arzt',
          id: 'Arzt',
          icon: 'user-md',
          type: 'String'
        }
      ],
      titleVerlaufBedarfsmedikation: [
        {
          title: 'Medikament',
          id: 'Medikament',
          icon: 'medkit',
          type: 'String'
        },
        {
          title: 'Menge',
          id: 'Menge',
          icon: 'check-square',
          type: 'String'
        },
        {
          title: 'Änderung von',
          id: 'AenderungVon',
          icon: 'user-circle',
          type: 'String'
        },
        {
          title: 'Reaktion',
          id: 'Reaktion',
          icon: 'flask',
          type: 'String'
        },
        {
          title: 'Schicht',
          id: 'Schicht',
          icon: '',
          type: 'ID'
        },
      ]
    }
  },

  created() {
    this.loadBedarfsmedikation()
  },

  methods: {
    handlePaneOpened(num) {
      if (this.openPaneNum == num) {
        return (this.openPaneNum = null)
      }
      this.openPaneNum = num;
    },

    courseFandlePaneOpened(num) {
      if (this.openPaneNumCourse == num) {
        return (this.openPaneNumCourse = null)
      }
      this.openPaneNumCourse = num;
    },

    selectValue(value) {
      if(value) {
        this.valueSelected = true
        this.selectedItem = value
        let obj = this.bedarfsmedikation.find(key => {
            this.medication.id = key.Id
            this.medication.grund = key.Grund
            return key.Id === value
        });

        this.selectedBedarfsmedikation = obj
        this.bedarfsmedikationId = this.selectedBedarfsmedikation.Id
        this.loadBedarfsMedikamenteRequest()
      }
    },

    openCourseModal () {
      this.loadBedarfsMedikamenteRequest()
      this.courseModal = !this.courseModal
    },

    closeCourseModal () {
      this.courseModal = false
      this.medicine = []
    },

    close () {
      this.modalDelete = false
    },

    closeSettings () {
      this.modalSetting = false
      this.isChecked = false
    },

    openDeleteModal(id) {
      this.modalDelete = !this.modalDelete
      this.deleteMedicineID = id
    },

    loadBedarfsMedikamenteRequest () {
       this.$http.get(`Bedarfsmedikation/Medikamente/${this.bedarfsmedikationId}`)
        .then(res => {
          this.loading = true
          this.medicine = []
          if(res.data.data) {
            res.data.data.find(key => {
              this.medicine.push({ 'text': key.adMedikament_Name, 'value': key.adMedikament_Id })
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    loadBedarfsmedikation () {
      // Check for showing the deleted Medications
      if (this.isChecked === true) {
        this.url = `Bedarfsmedikation/${this.roomID}/1`
      } else {
        this.url = `Bedarfsmedikation/${this.roomID}`
      }

      this.$http.get(this.url)
        .then(res => {
          this.loading = true
          if(res.data.data) {
            let medicationArray = res.data.data

            //set drop down data
            let bedarfsmedikationArray = []

            let selectedValue = this.selectedItem
            medicationArray.map(function(value) {
              let bool = value.Id === selectedValue ? true : false
              const element = { 'text': value.Grund, 'value': value.Id ,'selected': bool }
              bedarfsmedikationArray.push(element)
            })
            this.selectOption = bedarfsmedikationArray
            this.bedarfsmedikation = medicationArray
          }
        })
        .finally(() => {
          this.loading = false
          this.modalSetting = false
        })
    },

    deleteMedicine () {
       let data = {
        AenderungVon: this.loginUser.username,
        Id: this.deleteMedicineID,
      }
      this.$http.put('/Bedarfsmedikation', data)
        .then(res => {
          if(res.data) {
              this.$notify.success({message: 'Beenden Sie die Einnahme von Medikament erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
              this.close()
          }else {
              this.$notify.error({message: 'Gescheitert!! Medikament absetzen', position: 'top right', closeButton: false, timeOut: 5000})
          }
        })
        .catch((error) => {
          this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
        })
        .finally(() => {
          this.loading = false
          this.deleteMedicineID = null
          this.close()
          this.loadBedarfsmedikation()
        })
    }
  }
}
</script>
